var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Twitter_32_32",
    "data-name": "Twitter 32*32",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7411",
    "data-name": "Rectangle 7411",
    width: 24,
    height: 24,
    fill: "rgba(255,255,255,0)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_17787",
    "data-name": "Group 17787",
    transform: "translate(1.601 1.601)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_269",
    "data-name": "Ellipse 269",
    cx: 14,
    cy: 14,
    r: 14,
    transform: "translate(0.399 0.399)",
    fill: "#adb5b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11055",
    "data-name": "Path 11055",
    d: "M11.046,8.152,17.331,1H15.842L10.38,7.2,6.027,1H1l6.59,9.38L1,17.878H2.489l5.761-6.56,4.6,6.554h5.027ZM9.007,10.466l-.668-.938L3.026,2.1H5.313L9.6,8.1l.666.938,5.573,7.793H13.553Z",
    transform: "translate(4.961 4.961)",
    fill: "#ededed"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/Twitter.76ba1a5da82390085c5d709b23fd7e6c.svg";
export { ForwardRef as ReactComponent };